export let Screen;

(function (Screen) {
  Screen["Checkout"] = "checkout";
  Screen["Bundling"] = "bundling";
  Screen["BundleSummary"] = "bundle_summary";
  Screen["Brands"] = "brands";
  Screen["ExpiredCardModal"] = "expired_card_modal";
  Screen["DeliveryInstructions"] = "delivery_instructions";
  Screen["Item"] = "item";
  Screen["MessageReply"] = "message_reply";
  Screen["MessageList"] = "message_list";
  Screen["MessageNew"] = "message_New";
  Screen["PhoneVerification"] = "verification_prompt_phone";
  Screen["PhoneVerificationCheck"] = "verification_prompt_phone_check";
  Screen["TwoFactorAuthentication"] = "two_factor_authentication";
  Screen["ItemUpload"] = "upload_item";
  Screen["ItemEdit"] = "edit_item";
  Screen["ItemDraft"] = "edit_draft";
  Screen["ItemReservation"] = "item_reservation";
  Screen["ItemMarkAsSold"] = "item_mark_as_sold";
  Screen["UserProfile"] = "user_profile";
  Screen["UserAbout"] = "user_info";
  Screen["CurrentUserProfile"] = "current_user_profile";
  Screen["TrackShipmentView"] = "track_shipment_view";
  Screen["OrderDetails"] = "order_details";
  Screen["PaymentOptions"] = "payment_options";
  Screen["RequestToReturn"] = "request_to_return";
  Screen["DropOffPointInformation"] = "dropoff_point_information";
  Screen["ComplaintProof"] = "complaint_proof";
  Screen["ShippingSettings"] = "shipping_settings";
  Screen["SubscriptionSettings"] = "subscription_settings";
  Screen["PaymentSettings"] = "payment_settings";
  Screen["PrivacySettings"] = "privacy_settings";
  Screen["ProfileSettings"] = "profile_settings";
  Screen["PoliciesSettings"] = "policies_settings";
  Screen["KycMain"] = "identity_confirmation";
  Screen["KycAddressModal"] = "billing_address_update";
  Screen["KybEducation"] = "kyb_education";
  Screen["KybForm"] = "kyb_form";
  Screen["KycDocumentDeleteModal"] = "delete_documents_modal";
  Screen["KycClosingModal"] = "closing_modal";
  Screen["KycStatus"] = "status_screen";
  Screen["KycConfirmIdentityModal"] = "confirm_identity_modal";
  Screen["KycBankStatementEducation"] = "kyc_bank_statement_education";
  Screen["KycAddressProofEducation"] = "address_proof_education";
  Screen["MergeAnnouncement"] = "announcement";
  Screen["MergeAnnouncementTarget"] = "announcement_target";
  Screen["MergeGoToOldPortal"] = "go_to_old_portal";
  Screen["GetShippingLabel"] = "get_shipping_label";
  Screen["DonationsOverview"] = "donations_overview";
  Screen["FundraiserOverview"] = "donations_overview";
  Screen["DonationsSetup"] = "donations_set_up";
  Screen["FundraiserSetup"] = "donations_set_up";
  Screen["FavoriteItemList"] = "favorite_item_list";
  Screen["RecommendedItemsList"] = "recommended_items_list";
  Screen["Catalog"] = "catalog";
  Screen["Welcome"] = "welcome";
  Screen["Balance"] = "balance";
  Screen["OrdersList"] = "orders_list";
  Screen["RefundStatus"] = "refund_status";
  Screen["PickupPointMap"] = "dropoff_point_map";
  Screen["PickupPointList"] = "dropoff_point_list";
  Screen["HomeDeliverySelection"] = "home_delivery_selection";
  Screen["CaptchaPage"] = "captcha_page";
  Screen["PaymentsAccount"] = "payments_account";
  Screen["PaymentsAccountInTransaction"] = "payments_account_in_transaction";
  Screen["BillingAddressUpdate"] = "billing_address_update";
  Screen["DropoffTypeSelection"] = "dropoff_type_selection";
  Screen["BankAccount"] = "bank_account";
  Screen["BuyerInvoiceDetails"] = "b2c_buyer_invoice_details";
  Screen["CreditCardAdd"] = "credit_card_add";
  Screen["SaveCreditCardReminder"] = "save_credit_card_reminder";
  Screen["TransactionCancellationReasons"] = "transaction_cancellation_reasons";
  Screen["ContactForm"] = "contact_form";
  Screen["ReturnAddress"] = "return_address";
  Screen["RegistrationBusinessDetails"] = "registration_business_details";
  Screen["RegistrationBusinessRepresentative"] = "registration_business_representative";
  Screen["RegistrationBusinessAddress"] = "registration_business_address";
  Screen["RegistrationBusinessProfile"] = "registration_business_profile";
  Screen["WalletConversion"] = "wallet_conversion";
  Screen["WalletConversionFailed"] = "wallet_conversion_failed";
  Screen["BusinessHomepage"] = "business_homepage";
  Screen["DigitalLabel"] = "digital_label";
  Screen["ReferralHowItWorks"] = "referral_info_items";
  Screen["ReferralInvite"] = "referral_invite";
  Screen["ReferralsFriendsList"] = "registered_referrals_list";
  Screen["ReferralsRewardsList"] = "referrals_rewards_list";
  Screen["ReferralProgramOff"] = "referral_info_items_program_off";
  Screen["ContactDetails"] = "contact_details";
  Screen["SellerContactDetails"] = "seller_contact_details";
  Screen["ConfirmEverythingIsOkModal"] = "confirm_everything_is_ok_modal";
  Screen["InsufficientBalanceModal"] = "insufficient_balance_modal";
  Screen["KycEducation"] = "kyc_education";
  Screen["EscrowOnboarding"] = "escrow_onboarding";
  Screen["DocumentUploadTips"] = "document_upload_tips";
  Screen["ProductFeedbackForm"] = "product_feedback_form";
  Screen["MergeMissingInformation"] = "merge_missing_information";
  Screen["FillZipCodeAfterListing"] = "fill_zip_code_after_listing";
  Screen["CrmInAppMessage"] = "crm_in_app_message";
  Screen["SellerPolicies"] = "seller_policies";
  Screen["EditBusinessAddress"] = "edit_business_address";
  Screen["EditReturnAddress"] = "edit_return_address";
  Screen["PushUpOrderConfirmation"] = "push_up_order_confirm";
  Screen["PushUpOrderReview"] = "push_up_order_review";
  Screen["PushUpTeaser"] = "push_up_teaser";
  Screen["ClosetPromotionOrderConfirmation"] = "closet_promo_confirm";
  Screen["FreeReturnLabelModal"] = "free_return_label_modal";
  Screen["ClosetPromotionOrderReview"] = "closet_promo_prepare";
  Screen["EscrowFeeEducationModal"] = "escrow_fee_education";
  Screen["LabelTypeSelection"] = "label_type_selection";
  Screen["DirectDonation"] = "direct_donation";
  Screen["PriceBreakdownModal"] = "price_breakdown_modal";
  Screen["DirectDonationOrderConfirmation"] = "direct_donation_order_confirm";
  Screen["ContactSupport"] = "contact_support";
  Screen["ImprovementTips"] = "improvement_tips";
  Screen["ReturnOrder"] = "return_order";
  Screen["RequestItemReturn"] = "request_item_return";
  Screen["Unknown"] = "unknown";
  Screen["FeaturedCollection"] = "featured_collection";
  Screen["FeaturedCollectionItemSelection"] = "featured_collection_item_selection";
  Screen["FeaturedCollectionEdit"] = "featured_collection_edit";
  Screen["FeaturedCollectionOrderConfirm"] = "featured_collection_order_confirm";
  Screen["ItemUploadFeedbackForm"] = "item_upload_feedback_form";
  Screen["SizesModal"] = "sizes_modal";
  Screen["MobileCatalogFilters"] = "search_filter";
  Screen["MobileCatalogFilter"] = "filter_catalog_selection";
  Screen["CategoryIntentSelection"] = "category_intent_selection";
  Screen["BuyerOriginatingOffer"] = "buyer_originating_offer";
  Screen["InfoAboutMeasurements"] = "info_about_measurements";
  Screen["FastShippingEducation"] = "fast_shipping_education";
  Screen["NewsFeed"] = "news_feed";
  Screen["DynamicFilter"] = "dynamic_filter";
  Screen["MandatoryEmailVerification"] = "mand_email_verification";
  Screen["MandatoryEmailVerificationStart"] = "mand_email_verification_start";
  Screen["MandatoryEmailVerificationEnterCode"] = "mand_email_verification_enter_code";
  Screen["MandatoryEmailVerificationResendCode"] = "mand_email_verification_resend_code";
  Screen["MandatoryEmailVerificationSuccess"] = "mand_email_verification_success";
  Screen["BlikCodeRequest"] = "blik_code_request";
  Screen["MultiplePushUp"] = "multiple_push_up";
  Screen["Forum"] = "forum";
  Screen["ForumPosts"] = "forum_posts";
  Screen["ForumTopic"] = "forum_topic";
  Screen["ConversationList"] = "message_list";
  Screen["ConversationNew"] = "message_new";
  Screen["ConversationReply"] = "message_reply";
  Screen["ConversationEducation"] = "first_sale_education_screen";
  Screen["ConversationHAOVEducation"] = "haov_first_sale_education_screen";
  Screen["Sustainability"] = "sustainability";
  Screen["About"] = "about";
  Screen["HowItWorks"] = "how_it_works";
  Screen["VasOptionSelectionDrawer"] = "vas_option_selection_drawer";
  Screen["VasGalleryValueProposition"] = "vas_gallery_value_proposition";
  Screen["VasGalleryHelp"] = "vas_gallery_help";
  Screen["VasGalleryOrderConfirm"] = "vas_gallery_order_confirm";
  Screen["VasGalleryMultiSelection"] = "multi_gallery_selection";
  Screen["UserItemsManagement"] = "user_items_management";
  Screen["HelpRoot"] = "help_root";
  Screen["NotificationList"] = "notification_list";
  Screen["TermsAndConditions"] = "terms_view";
  Screen["TermsAndConditionsForced"] = "force_accept_terms_and_conditions";
  Screen["ProfileTab"] = "profile_tab";
  Screen["PackageSizeEducation"] = "package_size_education";
  Screen["PhotoEditing"] = "photo_editing";
  Screen["AdminAlerts"] = "admin_alerts";
  Screen["HelpCenterTransaction"] = "help_center_transaction";
  Screen["HelpCenterFaq"] = "help_center_faq";
  Screen["HelpCenterSearch"] = "help_center_search";
  Screen["HelpCenterRecentTransactions"] = "help_center_recent_transactions";
  Screen["TaxpayersCountryOfTaxResidencyModal"] = "taxpayers_country_selection";
  Screen["TaxpayersEducationModal"] = "taxpayers_education";
  Screen["TaxpayersForm"] = "taxpayers_info_submission_form";
  Screen["TaxpayersTaxIdentificationNumberEducationModal"] = "taxpayers_tin_education";
  Screen["TaxpayersStaticPlacement"] = "taxpayers_info_display";
  Screen["DeleteAccount"] = "delete_account";
  Screen["DeleteAccountSuccess"] = "delete_account_success";
  Screen["FeedSizeCategories"] = "feed_size_categories";
  Screen["BrowseAllBrands"] = "browse_all_brands";
  Screen["UserMigration"] = "user_migration";
  Screen["ReturnLabeOrderConfirm"] = "return_label_order_confirm";
  Screen["ReferralCodeShare"] = "referral_code_share";
  Screen["ChangeForgotPassword"] = "change_forgot_password";
  Screen["ChangePassword"] = "change_password";
  Screen["ViewIssueDetails"] = "view_issue_details";
  Screen["IntellectualPropertyInfringement"] = "intellectual_property_infringement";
  Screen["NoticeAndActionForm"] = "notice_and_action_form";
  Screen["Homepage"] = "homepage";
  Screen["ExtraServicePendingPaymentModal"] = "payment_pending_modal";
  Screen["HelpCenterHome"] = "help_center_home";
  Screen["UserFollow"] = "personalize_member_follow";
  Screen["Followers"] = "followers";
  Screen["Following"] = "following";
  Screen["UserSearch"] = "users";
  Screen["Advertising"] = "advertising";
  Screen["CodeLogin"] = "code_login";
  Screen["Bank2FAVerification"] = "bank_2fa_verification";
  Screen["DeskPostTicketSurveyForm"] = "desk_post_ticket_survey_form";
  Screen["ChangeEmail"] = "change_email";
  Screen["ConfirmEmail"] = "confirm_email";
  Screen["FullNameConfirmation"] = "full_name_confirmation";
  Screen["ProcessingListingStatusModal"] = "processing_listing_modal";
  Screen["CreatePhoneNumber"] = "create_phone_number";
  Screen["ChangePhoneNumber"] = "change_phone_number";
  Screen["EmailRegister"] = "email_register";
  Screen["Banned"] = "banned";
  Screen["SecuritySessions"] = "security_sessions";
  Screen["SecurityAuthentication"] = "security_authentication";
  Screen["SecuritySettings"] = "security_settings";
  Screen["AccountSettings"] = "account_settings";
  Screen["ResetPassword"] = "password_change";
  Screen["Authentication"] = "authentication";
  Screen["RequestDataExport"] = "request_data_export";
  Screen["EmailVerification"] = "email_verification";
  Screen["SelectLoginType"] = "select_login_type";
  Screen["UserVerification"] = "user_verification";
  Screen["WalletSetup"] = "payments_account";
  Screen["InfoBoard"] = "info_board";
  Screen["InfoPost"] = "info_post";
  Screen["ClosetPromotionStatistics"] = "cp_stats";
  Screen["NewPayout"] = "new_payout";
  Screen["PayoutStatus"] = "payout_status";
  Screen["WalletInvoices"] = "wallet_invoices";
  Screen["IncomeReports"] = "income_reports";
  Screen["NotificationLandings"] = "notification_landings";
  Screen["FaqEntry"] = "faq_entry";
  Screen["SatisfactionSurvey"] = "satisfaction_survey";
  Screen["PrivacyPolicy"] = "privacy_policy";
  Screen["WalletHistoryOverview"] = "wallet_history_overview";
  Screen["WalletHistory"] = "wallet_history";
  Screen["CookiePolicy"] = "cookie_policy";
  Screen["CommonText"] = "common_text";
  Screen["FeedbackEdit"] = "feedback_edit";
  Screen["DropOffPointMap"] = "drop_off_point_map";
  Screen["PhotosMetadataNote"] = "photos_metadata_note";
  Screen["Appeal"] = "appeal";
  Screen["SellerDropOffMap"] = "seller_drop_off_map";
  Screen["DsaNoticeAppeal"] = "dsa_notice_appeal";
  Screen["DsaNtdAppeal"] = "dsa_ntd_appeal";
  Screen["PrivateBetaTermsOfUse"] = "private_beta_terms_of_use";
  Screen["ProTermsOfUse"] = "pro_terms_of_use";
  Screen["VasComparison"] = "vas_comparison";
  Screen["FeedbackNew"] = "user_leave_feedback";
  Screen["SafetyPolicy"] = "safety_policy";
  Screen["TaxRules"] = "taxpayers_tax_rules";
  Screen["MoreHomepageItems"] = "more_homepage_items";
  Screen["ItemVerification"] = "item_verification";
  Screen["CollectionsListManagement"] = "collections_list_management";
  Screen["Dac7"] = "dac7";
  Screen["DsaAppealEducation"] = "dsa_appeal_education";
  Screen["App"] = "app";
  Screen["OfflineVerificationFeedbackForm"] = "offline_verification_feedback_form";
  Screen["BundleDiscountSettings"] = "bundle_discount_settings";
  Screen["BrandsByLetter"] = "brands_by_letter";
})(Screen || (Screen = {}));